import { render, staticRenderFns } from "./FormPhonesField.vue?vue&type=template&id=08f06c36&"
import script from "./FormPhonesField.vue?vue&type=script&lang=js&"
export * from "./FormPhonesField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports